import { withStyles } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { submit } from 'redux-form';
import { EXTERNAL_IDENTITY_PROVIDERS, GREEN } from '../../_config/consts.js';
import EmailSendIconCustom from '../../components/CustomIcons/EmailSendIconCustom.jsx';
import LoginFormContainer from '../../components/forms/LoginForm/LoginFormContainer.jsx';
import PasswordRecoveryForm from '../../components/forms/LoginForm/PasswordRecoveryForm.jsx';
import LoginWithChainels from '../../components/Login/LoginWithChainels.jsx';
import LoginWithCobot from '../../components/Login/LoginWithCobot.jsx';
import LoginWithEmailOTP from '../../components/Login/LoginWithEmailOTP.jsx';
import LoginWithNexudus from '../../components/Login/LoginWithNexudus.jsx';
import LoginWithOfficeRnd from '../../components/Login/LoginWithOfficeRnd.jsx';
import LoginWithSAML from '../../components/Login/LoginWithSAML.jsx';
import MDButton from '../../components/MDButton/MDButton.jsx';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UserActions from '../../redux/actions/user.actions';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    backgroundColor: '#f5f5f5',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to bottom, rgba(21, 116, 149, 0.85), rgba(21, 116, 149, 0.7))',
    },
  },
  container: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    maxWidth: 600,
    padding: 40,
    backgroundColor: 'white',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
      padding: 24,
      borderRadius: 8,
    },
  },
  header: {
    textAlign: 'center',
    marginBottom: 10,
  },
  logo: {
    width: 180,
    height: 'auto',
    marginBottom: 0,
    '@media (max-width: 768px)': {
      width: 150,
    },
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    color: '#157495',
    marginBottom: 10,
    marginTop: 10,
    '@media (max-width: 768px)': {
      fontSize: 24,
    },
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    marginTop: 0,
    '@media (max-width: 768px)': {
      fontSize: 14,
    },
  },
  copyright: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    color: 'white',
    fontSize: 12,
    textAlign: 'center',
    zIndex: 2,
    '& a': {
      color: 'white',
      textDecoration: 'underline',
    },
  },
});

@withRouter
@connect(state => ({ 
  userCredentials: state.user.userLogin, 
  companyConfigurations: state.user.companyConfigurations,
  loginContent: state.user.loginContent,
}))
class BookeyLogin extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    document.addEventListener('keydown', e => this.onSubmitPressed(e), false);
    dispatch(UserActions.fetchLoginContent());
    dispatch(UserActions.editField('isBookeyLogin', true));
  }
  
  componentWillUnmount() {
    document.removeEventListener('keydown', e => this.onSubmitPressed(e), false);
  }
  
  onSubmitPressed(e) {
    if (e.keyCode === 13) {
      if (e.repeat) return;
      const { dispatch } = this.props;
      dispatch(submit('LoginForm'));
    }
  }

  async makeLogin(loginData) {
    const { dispatch } = this.props;
    const { email, password } = loginData;

    try {
      // verifyUser navigates to /bookey/reserve on success when isBookeyLogin
      await dispatch(UserActions.verifyUser(email, password));
    } catch (error) {
      // Stay on /bookey/login; error modal already shown by verifyUser
      console.error('Login error:', error);
    }
  }

  getIDPLoginButton(idp) {
    if (!_.includes(idp.availablePlatforms, 'FE')) {
      return null;
    }

    if (idp && idp.type) {
      switch (idp.type) {
        case EXTERNAL_IDENTITY_PROVIDERS.SAML:
          return <LoginWithSAML idp={idp} />;
        case EXTERNAL_IDENTITY_PROVIDERS.NEXUDUS:
          return <LoginWithNexudus idp={idp} />;
        case EXTERNAL_IDENTITY_PROVIDERS.OTP_EMAIL:
          return <LoginWithEmailOTP idp={idp} />;
        case EXTERNAL_IDENTITY_PROVIDERS.COBOT:
          return <LoginWithCobot idp={idp} />;
        case EXTERNAL_IDENTITY_PROVIDERS.OFFICERND:
          return <LoginWithOfficeRnd idp={idp} />;
        case EXTERNAL_IDENTITY_PROVIDERS.CHAINELS:
          return <LoginWithChainels idp={idp} />;
        default:
          return null;
      }
    }
  }

  showForgotPassword() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONTENT_MODAL',
      modalProps: {
        title: <Entity entity="passwordForget" />,
        content: (
          <div style={{ marginTop: 50, display: 'flex', flexDirection: 'column' }}>
            <EmailSendIconCustom style={{ width: 60, alignSelf: 'center', color: GREEN }} />
            <h4 style={{ color: '#3f3f3f', marginBottom: 0, textAlign: 'center' }}>
              <Entity entity="passwordForgetDescription" />
            </h4>
            <PasswordRecoveryForm
              onSubmit={recoveryData => this.sendResetPassword(recoveryData)}
            />
            <MDButton
              backgroundColor="#157495"
              title={<Entity entity="passwordRecoveryButton" />}
              onClick={() => dispatch(submit('PasswordRecoveryForm'))}
            />
          </div>
        ),
        onConfirmText: <Entity entity="gotcha" />,
        modalStyle: { height: '90% !important' },
        onOutsideClick: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async sendResetPassword(recoveryData) {
    const { dispatch } = this.props;
    dispatch(ModalActions.hideModal());
    await dispatch(UserActions.forgotPassword(recoveryData.email));
  }

  render() {
    const { classes, companyConfigurations } = this.props;
    const externalIDP = !_.isEmpty(companyConfigurations) && companyConfigurations.externalIDP;

    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.header}>
            <img 
              src="/imgs/common/logoJagoDark.png" 
              alt="Jago Logo" 
              className={classes.logo}
            />
            <h1 className={classes.title}>
              <Entity entity="bookeyReservationSystem" />
            </h1>
          </div>
          <LoginFormContainer
            hideHeaderAndDescription={true}
            onSubmit={loginData => this.makeLogin(loginData)}
            onForgotPassword={() => this.showForgotPassword()}
            externalIDP={externalIDP}
            invitationsActive={false}
            getIDPLoginButton={idp => this.getIDPLoginButton(idp)}
          />
        </div>
        
        <div className={classes.copyright}>
        <span style={{ fontSize: 10 }}>Luckey Web {process.env.REACT_APP_FRONTEND_VERSION} - Sofia part of ISEO© {moment().year()}. All rights reserved. <span style={{ fontSize: 10 }}><a href="https://sofialocks.com/en/privacy-policy/" target="_blank"><Entity entity="privacyPolicy" /></a></span></span>
          <br />
          <span style={{ fontSize: 10 }}>Sofia SRL - VAT: IT09129330966</span>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BookeyLogin);
